import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';

// override StyledMainButton if needed.
const StyledDarkButton = styled.button`
  cursor: pointer;
  width: 140px;
  height: 44px;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.35s ease-in;
  right: 30px;
  z-index: 1;
  &:active {
    background-color: rgba(30, 144, 255, 0.3);
  }
  ${media.phone`
    top: 60px;
  `}
`;

class DarkButton extends Component {
  render() {
    return (
      <StyledDarkButton onClick={this.props.nextPage} align={this.props.options.align} style={this.props.options.style}>
        {this.props.options.title}
      </StyledDarkButton>
    );
  }
}

export default DarkButton;



// WEBPACK FOOTER //
// ./src/components/instore/DarkButton.js